import "./style.css";

export default function LogosHeader() {
  return (
    <div className="logos-header">
      <img 
        src="/visor incendios_fondo claro.png" 
        alt="Logo" 
        className="logos-header-image"
      />
    </div>
  );
}
